import PageLayout, { Section } from "./PageLayout";
import { Download, Mail, Newspaper } from "lucide-react";

const RELEASES = [
  { date: "Feb 8, 2026", title: "Djino Stream surpasses 1M streams/day across African originals", excerpt: "The platform credits its growth to investment in Congolese and Nigerian content." },
  { date: "Jan 22, 2026", title: "Djino Originals slate announced for 2026", excerpt: "Twelve new films and series — including six African productions — debut this year." },
  { date: "Dec 14, 2025", title: "Djino Stream raises Series A, valuing the company at $80M", excerpt: "Funds will accelerate product expansion and content investment across emerging markets." },
  { date: "Oct 2, 2025", title: "Djino Stream launches Live TV with 200+ free channels", excerpt: "Free, ad-supported live TV is now available in all subscription tiers." },
];

export default function Press() {
  return (
    <PageLayout
      eyebrow="Press"
      title="Press & Media"
      subtitle="News, brand assets and the latest from Djino Stream."
    >
      <Section title="Press releases">
        <div className="space-y-3">
          {RELEASES.map((r, i) => (
            <div key={i} className="bg-[#0d0d0d] border border-white/5 rounded-xl p-5 hover:border-[#E50914]/40 transition" data-testid={`press-${i}`}>
              <div className="text-xs text-[#888] uppercase tracking-wider mb-1.5 flex items-center gap-2"><Newspaper size={14} /> {r.date}</div>
              <div className="font-bold text-lg mb-1.5" style={{ fontFamily: "Outfit" }}>{r.title}</div>
              <div className="text-sm text-[#aaa]">{r.excerpt}</div>
            </div>
          ))}
        </div>
      </Section>

      <Section title="Media kit">
        <div className="grid sm:grid-cols-2 gap-4">
          <a href="#" className="group bg-[#0d0d0d] border border-white/5 rounded-xl p-6 hover:border-[#E50914]/40 transition flex items-center gap-4" data-testid="brand-assets-dl">
            <div className="w-12 h-12 rounded-lg bg-[#E50914]/15 text-[#E50914] flex items-center justify-center flex-shrink-0">
              <Download size={22} />
            </div>
            <div className="flex-1">
              <div className="font-bold" style={{ fontFamily: "Outfit" }}>Brand assets (.zip)</div>
              <div className="text-xs text-[#888]">Logos, wordmark, color palette, brand guide</div>
            </div>
          </a>
          <a href="#" className="group bg-[#0d0d0d] border border-white/5 rounded-xl p-6 hover:border-[#E50914]/40 transition flex items-center gap-4" data-testid="fact-sheet-dl">
            <div className="w-12 h-12 rounded-lg bg-[#E50914]/15 text-[#E50914] flex items-center justify-center flex-shrink-0">
              <Download size={22} />
            </div>
            <div className="flex-1">
              <div className="font-bold" style={{ fontFamily: "Outfit" }}>Fact sheet (.pdf)</div>
              <div className="text-xs text-[#888]">Company facts, stats and executive bios</div>
            </div>
          </a>
        </div>
      </Section>

      <Section title="Press contact">
        <div className="bg-[#0d0d0d] border border-white/5 rounded-xl p-6 flex items-start gap-4">
          <div className="w-12 h-12 rounded-lg bg-[#E50914]/15 text-[#E50914] flex items-center justify-center flex-shrink-0">
            <Mail size={20} />
          </div>
          <div>
            <div className="font-bold mb-1" style={{ fontFamily: "Outfit" }}>Solange Kabongo, Head of Communications</div>
            <a href="mailto:press@djinostream.com" className="text-[#E50914] hover:underline">press@djinostream.com</a>
            <div className="text-xs text-[#888] mt-1">Response within 24 hours, Mon–Fri.</div>
          </div>
        </div>
      </Section>
    </PageLayout>
  );
}
